import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spin, Button } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import { useHistory } from "react-router-dom";
import CustomizeRewards from "../../../assets/images/customise-the-reward.png";
import BonusLoyalty from "../../../assets/images/bonus-loyalty.png";
import LoyaltyRedemption from "../../../assets/images/loyalty-redemption.png";
import { useDispatch, useSelector } from "react-redux";
import { loadLoyaltyEnableDisable } from "../../../appRedux/actions/CommonData";

const Loyalty = (props) => {
  const isDisable = props.isDisable ? props.isDisable : false;
  const history = useHistory();
  const dispatch = useDispatch();
  const [confirmLoading, setConfirmLoading] = useState(false); // change state
  const redirectAdd = () => {
    history.push("/Dashboard/Setup/Loyalty/add");
  };

  return (
    <Spin spinning={confirmLoading} size="large">
      <>
        <div className="Content-wrapper">
              
            <Row className="mt-4 mb-5">
              <Col md={24} className="custom-center-data">
                <h1 className="mb-0 text-center">
                  <IntlMessages id="setup.loyalty.title" />
                </h1>
                <p className="custom-storeadd-head text-center">
                  <IntlMessages id="setup.loyalty.subTitle" />
                </p>
                <Button
                  className=""
                  type="primary"
                  onClick={() => dispatch(loadLoyaltyEnableDisable(true))}
                  disabled={isDisable}
                >
                  <IntlMessages id="setup.loyalty.enableBtn" />
                </Button>
              </Col>
            </Row>
          
          <div className="mt-5">
            <Row>
              <Col lg={8} md={8} sm={24} xs={24}>
                <div className="gift-card-step">
                  <div className="Loyalty-imgs">
                  <img src={CustomizeRewards} alt="" className="" />
                  </div>
                  <h2 className="loyalty-step-heading-v1 mb-0 text-center">
                    <IntlMessages id="setup.loyalty.typeHeading1" />
                  </h2>
                  <p className="gift-card-step-details text-center">
                    <IntlMessages id="setup.loyalty.typeParagraph1" />
                  </p>
                </div>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <div className="gift-card-step">
                <div className="Loyalty-imgs">
                  <img src={BonusLoyalty} alt="" className="" />
                  </div>
                  <h2 className="loyalty-step-heading-v2 mb-0 text-center">
                    <IntlMessages id="setup.loyalty.typeHeading2" />
                  </h2>
                  <p className="gift-card-step-details text-center">
                    <IntlMessages id="setup.loyalty.typeParagraph2" />
                  </p>
                </div>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <div className="gift-card-step">
                <div className="Loyalty-imgs">
                  <img src={LoyaltyRedemption} alt="" className="" />
                  </div>
                  <h2 className="loyalty-step-heading-v3 mb-0 text-center">
                    <IntlMessages id="setup.loyalty.typeHeading3" />
                  </h2>
                  <p className="gift-card-step-details text-center">
                    <IntlMessages id="setup.loyalty.typeParagraph3" />
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </>
    </Spin>
  );
};

export default Loyalty;
